import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-754eaafc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-new-trade-specialism-modal !tw-border-none" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-new-trade-specialism-modal__label" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Service Category Name")
], -1))
const _hoisted_3 = { class: "tw-text-red-600" }
const _hoisted_4 = { class: "tw-w-full tw-flex tw-gap-3 tw-items-center tw-justify-end tw-pt-4 tw-border-t-dashed-custom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, {
    headerTitle: "Add New Trade Services",
    onOnClose: $setup.onClickCancelButton
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_v_form, {
          onSubmit: _withModifiers($setup.onClickAddCustomCategory, ["prevent"]),
          rules: $setup.validation,
          ref: "serviceAddFormRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              rules: $setup.validation.serviceName,
              placeholder: "Enter Category Name",
              class: "c-input input_field",
              "bg-color": "#fff",
              variant: "outlined",
              onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.errorAlert = '')),
              modelValue: $setup.customCategoryName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customCategoryName) = $event))
            }, null, 8, ["rules", "modelValue"])
          ]),
          _: 1
        }, 8, ["onSubmit", "rules"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString($setup.errorAlert), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          variant: "secondary",
          label: "Cancel",
          isCapitalize: true,
          onClick: $setup.onClickCancelButton,
          disabled: $setup.isloading,
          class: "!tw-w-auto"
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          variant: "accent",
          label: "Add",
          isCapitalize: true,
          onClick: $setup.onClickAddCustomCategory,
          isLoading: $setup.isloading,
          class: "!tw-w-auto"
        }, null, 8, ["onClick", "isLoading"])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}